(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentVersionPageDeleteController',DocumentVersionPageDeleteController);

    DocumentVersionPageDeleteController.$inject = ['$uibModalInstance', 'entity', 'DocumentVersionPage'];

    function DocumentVersionPageDeleteController($uibModalInstance, entity, DocumentVersionPage) {
        var vm = this;

        vm.documentVersionPage = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DocumentVersionPage.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
